import { checkIfGroupDeployment } from 'utils/deployment';

export default class RolePermission {
    components = ['arn', 'partition', 'service', 'region', 'tenant', 'resource'];
    constructor({ name = null, Statement = [] }) {
        Object.assign(this, {
            name,
            Statement: this.formatStatement(Statement)
        });
    }
    formatStatement(Statement) {
        const statement = [];
        for (const { Effect, Action, Resource } of Statement) {
            if (!['Allow', 'Deny'].includes(Effect)) {
                throw InvalidStatmentError(`Effect must be 'Allow' or 'Deny', supplied: ${Effect}`);
            }
            statement.push({
                Effect,
                Action: Action,
                Resource: this.formatArn(Resource)
            });
        }
        return statement;
    }

    formatArn(arnString) {
        let arn = {};
        let segments = /([\w\-.*]*):(.*)/;
        let arnContainer = arnString;
        this.components.forEach((segment) => {
            if (segment === 'resource') {
                return (arn[segment] = arnContainer);
            }
            let res = segments.exec(arnContainer);
            if (!Array.isArray(res)) {
                throw new InvalidArnError('Could not extract all segments of Arn.');
            }
            arn[segment] = res[1];
            arnContainer = res[2];
        });

        arn.resourceArr = arn.resource.split(/\/|:/);

        return arn;
    }

    resourceMatch(userResource, menuResource) {
        if (userResource['arn'] !== menuResource['arn']) {
            return false;
        }
        if (userResource['partition'] !== menuResource['partition']) {
            return false;
        }
        if (userResource['service'] !== menuResource['service']) {
            return false;
        }
        if (userResource['tenant'] !== menuResource['tenant'] && !checkIfGroupDeployment()) {
            return false;
        }
        if (userResource['resource'] !== '*') {
            const ur = userResource['resource'].split('/');
            const mr = menuResource['resource'].split('/');

            if (ur[0] !== mr[0]) {
                return false;
            }
        }
        return true;
    }

    isAuthorized(action, resource) {
        let isAuthorized = false;

        if (resource) {
            for (let { Effect, Action, Resource } of this.Statement) {
                if (action === 'CanUpdate' && resource?.tenant === 'study') {
                    console.log(resource, Action);
                }
                if (
                    (Action.indexOf(action) >= 0 || Action.indexOf('*') >= 0 || action === undefined) &&
                    this.resourceMatch(Resource, this.formatArn(resource))
                ) {
                    if (Effect === 'Deny') return false;
                    isAuthorized = true;
                }
            }
        }
        return isAuthorized;
    }
}
